import { Plus } from "react-feather";
import styles from "../../communication-chat.module.css";

const EmployeeGroupsUnread = (props) => {
  const items = props.items || [];
  const groups = items.filter((i) => i.type === "Group");
  const directMessages = items.filter((i) => i.type === "Employee");

  const getInitials = (name) => {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return (
      parts[0].charAt(0) + parts[parts.length - 1].charAt(0)
    ).toUpperCase();
  };

  const renderRow = (item) => (
    <div
      key={item.id}
      className={`${styles.CommuListSec}`}
      onClick={(e) => {
        e.stopPropagation();
        props.onSelect(item);
      }}
    >
      {item.type === "Employee" && (
        <div className={`${styles.EmployeeListDeSec}`}>
          <div className={`${styles.EmployeeAvatarSec}`}>
            {item._employee?.avatar ? (
              <img
                src={item._employee.avatar}
                alt=""
                className={`${styles.EmpAvatarImg}`}
              />
            ) : (
              <p className={`${styles.EmpAvatarInitials}`}>
                {getInitials(item.name)}
              </p>
            )}
            <span
              className={`${styles.StatusBadge} ${
                item._employee?.online ? styles.Online : ""
              }`}
            ></span>
          </div>

          <div className={`${styles.CommuListDeSec}`}>
            <p className={`${styles.ProsTenantList}`}>
              <span>{item.name}</span>
            </p>
            <p className={`${styles.ProsTenantListDe}`}>
              <span>
                {item.type === "Group"
                  ? (() => {
                      const names = item.subtitle
                        ? item.subtitle.split(", ")
                        : [];
                      if (names.length <= 3) return item.subtitle;
                      return `${names.slice(0, 3).join(", ")} +${
                        names.length - 3
                      }`;
                    })()
                  : item.subtitle}
              </span>
            </p>
          </div>
        </div>
      )}

      {item.type === "Group" && (
        <>
          <div className={`${styles.CommuListDeSec}`}>
            <p className={`${styles.ProsTenantList}`}>
              <span>{item.name}</span>
            </p>
            <p className={`${styles.ProsTenantListDe}`}>
              <span>
                {item.type === "Group"
                  ? (() => {
                      const names = item.subtitle
                        ? item.subtitle.split(", ")
                        : [];
                      if (names.length <= 3) return item.subtitle;
                      return `${names.slice(0, 3).join(", ")} +${
                        names.length - 3
                      }`;
                    })()
                  : item.subtitle}
              </span>
            </p>
          </div>

          <div className={`${styles.GroupAvatarSec}`}>
            {item.avatars.slice(0, 3).map((member, idx) => (
              <div key={idx} className={`${styles.GroupAvatar}`}>
                {member.avatar ? (
                  <img
                    src={member.avatar}
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <p
                    className={`${styles.EmpAvatarInitials}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "11px",
                      margin: 0,
                    }}
                  >
                    {getInitials(member.name)}
                  </p>
                )}
              </div>
            ))}
          </div>
        </>
      )}

      {item.unreadCount > 0 && (
        <span className={`${styles.PropertyGroupNotiCount}`}>
          {item.unreadCount}
        </span>
      )}
    </div>
  );

  return (
    <div>
      <div className={`${styles.TeamGroupTopHead}`}>
        <span>Group Conversations</span>
        {props.canManageGroups && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              props.onAddGroup && props.onAddGroup();
            }}
            className={`${styles.AddTeamBU}`}
          >
            <Plus size={10} /> Add Group
          </button>
        )}
      </div>

      {groups.map(renderRow)}
      {groups.length === 0 && (
        <div
          className={`${styles.NoDataSecOnlyText}`}
          style={{ padding: "10px 30px" }}
        >
          <p style={{ fontSize: "13px" }}>No group conversations yet</p>
        </div>
      )}

      <div className={`${styles.TeamSingleTopHead}`}>Direct Messages</div>

      {directMessages.map(renderRow)}
      {directMessages.length === 0 && (
        <div
          className={`${styles.NoDataSecOnlyText}`}
          style={{ padding: "10px 30px" }}
        >
          <p style={{ fontSize: "13px" }}>No direct messages yet</p>
        </div>
      )}
    </div>
  );
};

export default EmployeeGroupsUnread;
